import utils from 'components/utilsComponent';

/**
 * Задержка для callback, чтобы не спамить запросами
 */
let delayTimer = null;

function delay(callback, ms) {
    clearTimeout(delayTimer);
    delayTimer = setTimeout(function() {
        callback();
    }, ms || 0);
}

/**
 * Поиск по географии + объектам
 */
function HotelSearch(args) {
    /**
     * Возвращает селектор относительно контейнера
     */
    function cs(selector) {
        return $container.querySelectorAll(selector);
    }

    /**
     * Сохраняем данные в контейнер
     */
    function saveData(name, data) {
        if ($dataContainer && name) {
            $dataContainer.dataset[name] = data;
        }
    }

    /**
     * Сохраняем данные в форму
     */
    function saveFormData(inputClass, value) {
        if ($formContainer && inputClass) {
            let input = $formContainer.querySelector('.js-' + inputClass);
            if (input) {
                input.value = value;
            }
        }
    }

    // Входные данные
    let $container = args.container || null;
    let $dataContainer = args.dataContainer || null;
    let $formContainer = args.formContainer || null;
    let onSelectCallback = args.onSelectCallback || null;
    let onlyLinkMode = args.onlyLinkMode ? 1 : 0;
    let obj = null;
    let closeEvent = false;

    // AJAX обработчик
    let handler = null;

    // Объект ключей, используемых для взаимодействия с клавиатурой
    let keys = {
        'esc': 27,
        'tab': 9,
        'return': 13,
        'left': 37,
        'up': 38,
        'down': 40,
        'delete': 46,
        'backspace': 8
    };

    // Преобразование к нужному формату
    if (typeof $container === 'string') {
        $container = document.querySelector($container);
    }
    if (typeof $dataContainer === 'string') {
        $dataContainer = document.querySelector($dataContainer);
    }
    if (typeof $formContainer === 'string') {
        $formContainer = document.querySelector($formContainer);
    }

    const $searchInput = args.searchInput ? $container.querySelector(args.searchInput) : $container.querySelector('.js-searchInput, .js-searchCity');
    // Режимы: 'default' или 'hotelSelect' (поиск только по отелям)
    const mode = args.mode ? args.mode : 'default';
    const url = args.url ? args.url : '/main/search_results/';

    /**
     * Инициализация
     */
    this.init = function(initText) {
        // Ссылка на сам объект
        obj = this;

        // Проверяем, есть ли initText
        if (initText && initText !== '') {
            let formData = new FormData();
            formData.append('query', initText);
            formData.append('ol', onlyLinkMode);

            fetch(url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok') {
                    try {
                        let data = r.data.results_groups[0].list[0];
                        saveData('title', data.title);
                        saveFormData('geoId', data.pid);
                        saveFormData('hotelId', data.pid);
                        saveFormData('geoTypeId', data.tid);
                    } catch (e) {
                        // Игнорируем ошибки
                    }
                }
            });
        } else if (initText === '') {
            $searchInput.value = null;
        }

        /**
         * Открытие выпадающего меню
         */
        function openDropdown() {
            $container.classList.add('is-disclosed');

            let buttonAnimation = document.querySelector('.Button--animation');
            if (buttonAnimation) {
                buttonAnimation.classList.remove('is-loading');
            }

            // Разрешаем закрытие
            closeEvent = true;

            /**
             * Отслеживаем клики вне области выпадающего списка
             */
            function overClick(e) {
                if (!closeEvent || !$container.classList.contains('is-visible')) {
                    document.removeEventListener('click', overClick);
                    return;
                }

                const $wrapper = cs('.js-dropdownWrapper')[0];
                if ($wrapper && !$wrapper.contains(e.target)) {
                    $wrapper.remove();
                    $container.classList.remove('is-visible');

                    closeEvent = false;
                    document.removeEventListener('click', overClick);
                }
            }

            document.addEventListener('click', overClick);
        }

        function closeDropdown() {
            $container.classList.remove('is-visible');
            const $dropdownWrapper = cs('.js-dropdownWrapper')[0];
            if ($dropdownWrapper) {
                $dropdownWrapper.remove();
            }
        }

        /**
         * Инициируем поиск
         */
        function doSearch($searchInput) {
            const $form = $searchInput.closest('form');
            const $dropdown = $form.querySelector('.js-dropdownWrapper');
            const $wrapper = $form.querySelector('.js-hotelSearchWrapper');
            const query = $searchInput.value.trim();

            let $buttonAnimation = $form.querySelector('.Button--animation');

            $searchInput.removeAttribute('aria-activedescendant');

            if (query.length >= 3) {
                if ($buttonAnimation) {
                    $buttonAnimation.classList.add('is-loading');
                }
                // Останавливаем предыдущий запрос, если он есть
                if (handler) {
                    handler.abort();
                }

                handler = new AbortController();

                let formData = new FormData();
                formData.append('query', query);
                formData.append('ol', onlyLinkMode);

                // Отправляем запрос к серверу
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: formData,
                    signal: handler.signal,
                })
                .then(response => response.json())
                .then(r => {
                    if (r.status === 'ok') {
                        if ($dropdown) {
                            $dropdown.remove();
                        }
                        $searchInput.insertAdjacentHTML('afterend', r.data.content);
                        openDropdown();

                        const isActiveElement = $container.querySelector('.is-active');
                        if (isActiveElement) {
                            let geoIdElement = isActiveElement.querySelector('a[data-geo-id]');
                            let hotelIdElement = isActiveElement.querySelector('a[data-hotel-id]');
                            let geoTypeIdElement = isActiveElement.querySelector('a[data-geo-type-id]');

                            saveFormData('geoId', geoIdElement ? geoIdElement.getAttribute('data-geo-id') : null);
                            saveFormData('hotelId', hotelIdElement ? hotelIdElement.getAttribute('data-hotel-id') : null);
                            saveFormData('geoTypeId', geoTypeIdElement ? geoTypeIdElement.getAttribute('data-geo-type-id') : null);
                        }

                        if ($buttonAnimation) {
                            $buttonAnimation.classList.remove('is-loading');
                        }

                        // Добавляем обработчики кликов на новые элементы
                        let dropdownLinks = cs('.js-dropdownWrapper a');
                        dropdownLinks.forEach($link => {
                            $link.addEventListener('click', dropdownItemClickHandler);
                        });

                    } else if (r.status === 'error') {
                        if ($dropdown) {
                            $dropdown.remove();
                        }
                        closeDropdown();

                        if ($buttonAnimation) {
                            $buttonAnimation.classList.remove('is-loading');
                        }
                    }
                });
            } else {
                if ($wrapper) {
                    $wrapper.classList.remove('is-disclosed');
                }

                if ($buttonAnimation) {
                    $buttonAnimation.classList.remove('is-loading');
                }
            }
        }

        /**
         * Обработчик нажатия клавиш
         */
        function doKeypress(keys, e, elem) {
            let highligted = false;
            let $input = $searchInput;
            let $wrapper = $container;
            let $dropdown = cs('.js-dropdownWrapper')[0];

            if ($dropdown) {
                highligted = Array.from($dropdown.querySelectorAll('.is-active')).length > 0;
            }

            switch (e.keyCode || e.which) {
                case keys.esc:
                    $input.removeAttribute('aria-activedescendant');
                    // Убираем класс, чтобы скрыть выпадающий список
                    $wrapper.classList.remove('is-disclosed');
                    let $wrapperDropdown = $wrapper.querySelector('.js-dropdownWrapper');
                    if ($wrapperDropdown) $wrapperDropdown.remove();
                    break;

                case keys.tab:
                    $input.removeAttribute('aria-activedescendant');
                    // Убираем класс, чтобы скрыть выпадающий список
                    $wrapper.classList.remove('is-disclosed');
                    let $wrapperDropdownTab = $wrapper.querySelector('.js-dropdownWrapper');
                    if ($wrapperDropdownTab) $wrapperDropdownTab.remove();
                    break;

                case keys.return:
                    if (highligted) {
                        e.preventDefault();
                        e.stopPropagation();
                        return selectOption();
                    }
                    break;

                case keys.up:
                    e.preventDefault();
                    e.stopPropagation();
                    return moveUp(highligted);
                    break;

                case keys.down:
                    e.preventDefault();
                    e.stopPropagation();
                    return moveDown(highligted);
                    break;

                case keys.delete:
                case keys.backspace:
                    // Удаляем данные
                    saveData('geoId', '');
                    saveData('hotelId', '');
                    saveData('geoTypeId', '');
                    saveFormData('geoId', '');
                    saveFormData('hotelId', '');
                    saveFormData('geoTypeId', '');
                    break;
            }
        }

        /**
         * Метод выбора отмеченного пользователем пункта
         */
        function selectOption() {
            let $input = $searchInput;
            let $wrapper = $container;

            // Если есть куда перейти, то переходим
            let $elem = $wrapper.querySelector('.js-dropdownWrapper .is-active a');
            if (!$elem) return;

            let href = $elem.href || false;

            // Ссылки только у Отелей, у ГЕО сущностей данные сохраняем
            if (href) {
                location.href = href;
                return;
            }

            $input.removeAttribute('aria-activedescendant');
            // Заменяем введенный текст в input-е текстом из выбранного пункта
            let $optionDropdown = $elem.querySelector('.js-optionDropdown');
            $input.value = $optionDropdown ? $optionDropdown.textContent : '';

            // Фокус на input
            $input.focus();
            // Убираем класс, чтобы скрыть выпадающий список
            $wrapper.classList.remove('is-disclosed');

            let $dropdownWrapper = $wrapper.querySelector('.js-dropdownWrapper');
            if ($dropdownWrapper) $dropdownWrapper.remove();

            saveData('geoId', $elem.getAttribute('data-geo-id'));
            saveData('hotelId', $elem.getAttribute('data-hotel-id'));
            saveData('geoTypeId', $elem.getAttribute('data-geo-type-id'));
            saveFormData('geoId', $elem.getAttribute('data-geo-id'));
            saveFormData('hotelId', $elem.getAttribute('data-hotel-id'));
            saveFormData('geoTypeId', $elem.getAttribute('data-geo-type-id'));

            // Callback
            if (typeof onSelectCallback === 'function') {
                onSelectCallback();
            }
        }

        /**
         * Метод прокрутки вверх
         */
        function moveUp(highligted) {
            let $input = $searchInput;
            let $wrapper = $container;
            let $items = $wrapper.querySelectorAll('.Search__dropdown-item');
            let index = Array.from($items).findIndex($item => $item.classList.contains('is-active'));

            $input.removeAttribute("aria-activedescendant");

            let $elementActive = $wrapper.querySelector('.is-active');
            if (index > 0) {
                if ($elementActive) {
                    $elementActive.setAttribute('aria-selected', 'false');
                    $elementActive.classList.remove('is-active');
                }

                if ($items.length) {
                    let lastIndex = index - 1;

                    $items[lastIndex].classList.add('is-active');
                    $items[lastIndex].setAttribute('aria-selected', 'true');
                    $input.setAttribute('aria-activedescendant', $items[lastIndex].getAttribute('id'));
                }
            } else {
                if ($elementActive) {
                    $elementActive.setAttribute('aria-selected', 'false');
                    $elementActive.classList.remove('is-active');
                }

                if ($items.length) {
                    let lastIndex = $items.length - 1;

                    $items[lastIndex].classList.add('is-active');
                    $items[lastIndex].setAttribute('aria-selected', 'true');
                    $input.setAttribute('aria-activedescendant', $items[lastIndex].getAttribute('id'));
                }
            }
        }

        /**
         * Метод прокрутки вниз
         */
        function moveDown(highligted) {
            let $input = $searchInput;
            let $wrapper = $container;
            let $items = $wrapper.querySelectorAll('.Search__dropdown-item');
            let index = Array.from($items).findIndex($item => $item.classList.contains('is-active'));

            $input.removeAttribute("aria-activedescendant");

            let $elementActive = $wrapper.querySelector('.is-active');
            if (index < $items.length - 1) {
                if ($elementActive) {
                    $elementActive.setAttribute('aria-selected', 'false');
                    $elementActive.classList.remove('is-active');
                }

                if ($items.length) {
                    $items[index + 1].classList.add('is-active');
                    $items[index + 1].setAttribute('aria-selected', 'true');
                    $input.setAttribute('aria-activedescendant', $items[index + 1].getAttribute('id'));
                }
            } else {
                if ($elementActive) {
                    $elementActive.setAttribute('aria-selected', 'false');
                    $elementActive.classList.remove('is-active');
                }

                if ($items.length) {
                    $items[0].classList.add('is-active');
                    $items[0].setAttribute('aria-selected', 'true');
                    $input.setAttribute('aria-activedescendant', $items[0].getAttribute('id'));
                }
            }
        }

        /**
         * Обработчик для добавления активного класса input-ам и крестикам
         */
        utils.addTrigger('input', $searchInput, function() {
            let val = this.value;

            delay(() => doSearch(this), 500);

            if (val === '') {
                $container.classList.remove('is-visible');
                closeDropdown();
            } else {
                $container.classList.add('is-visible');
            }
        });

        /**
         * Обработчик работы с клавиатурой
         */
        utils.addTrigger('keydown', $searchInput, function(e) {
            if (this.closest) {
                doKeypress(keys, e, this.closest('.js-search-box'));
            }
        });

        /**
         * Обработчик клика по пункту из выпадающего списка
         */
        function dropdownItemClickHandler(e) {
            e.preventDefault();

            const $searchLink = document.querySelector('.js-searchMore');
            const $dropdown = this.querySelector('.js-optionDropdown');
            const $wrapper = cs('.js-dropdownWrapper')[0];
            const title = $dropdown ? $dropdown.textContent : '';

            // Выбор отеля из списка
            if (mode === 'hotelSelect') {
                const $hotelIdInput = $formContainer.querySelector('input[name="hotel_id"]');
                const $box = $formContainer.querySelector('.Form-application-hotel__box');

                $searchInput.classList.add('Form__input--hidden');
                $searchInput.value = title;

                if ($box) {
                    $box.innerHTML = $dropdown ? $dropdown.innerHTML : '';
                    $box.classList.add('is-active');
                }

                $hotelIdInput.value = $dropdown.getAttribute('data-id');

                closeEvent = false;
                if ($wrapper) {
                    $wrapper.remove();
                }

                return;
            }

            // Обработка ссылок
            const href = this.href;
            if (href !== undefined) {
                window.location.href = href;
                return;
            }

            // Копируем выбранный текст
            $searchInput.value = title;

            // Закрываем выпадающий список
            $container.classList.remove('is-visible');
            closeEvent = false;

            if (this.getAttribute('data-hotel-id')){
                $searchLink.style.display = 'none';
                let hiddenField = document.querySelector('.js-hiddenField');
                if (hiddenField) hiddenField.style.display = 'none';
            } else {
                $searchLink.style.display = 'block';
                $searchLink.classList.remove('is-hidden');
                let hiddenField = document.querySelector('.js-hiddenField');
                if (hiddenField) hiddenField.style.display = 'block';
            }

            // Сохраняем гео данные
            saveData('title', title);
            saveData('geoId', this.getAttribute('data-geo-id'));
            saveData('hotelId', this.getAttribute('data-hotel-id'));
            saveData('geoTypeId', this.getAttribute('data-geo-type-id'));
            saveFormData('geoId', this.getAttribute('data-geo-id'));
            saveFormData('hotelId', this.getAttribute('data-hotel-id'));
            saveFormData('geoTypeId', this.getAttribute('data-geo-type-id'));

            // Callback
            if (typeof onSelectCallback === 'function') {
                onSelectCallback();
            }
        }

        /**
         * Обработчик события клик по крестику
         */
        let searchCloseButtons = cs('.js-searchClose');
        searchCloseButtons.forEach(function($button) {
            utils.addTrigger('click', $button, function(e) {
                e.preventDefault();

                // Выбор отеля из списка
                if (mode === 'hotelSelect') {
                    let $box = $formContainer.querySelector('.Form-application-hotel__box');
                    if ($box) $box.classList.remove('is-active');

                    $searchInput.classList.remove('Form__input--hidden');
                    $searchInput.value = '';

                    $container.classList.remove('is-visible');
                    $container.classList.remove('is-disclosed');
                    return;
                }

                this.parentNode.querySelector('input').value = '';

                // Удаляем данные
                saveData('geoId', '');
                saveData('hotelId', '');
                saveData('geoTypeId', '');
                saveFormData('geoId', '');
                saveFormData('hotelId', '');
                saveFormData('geoTypeId', '');

                closeDropdown();
                $container.classList.remove('is-visible');
                $container.classList.remove('is-disclosed');

                // Callback
                if (typeof onSelectCallback === 'function') {
                    onSelectCallback();
                }
            });
        });
    }

    /**
     * Геттер данных поиска
     */
    this.get = function(name) {
        if ($dataContainer && name) {
            return $dataContainer.dataset[name];
        }
        return undefined;
    }
}

export default HotelSearch;
